import { render, staticRenderFns } from "./foodUpload.vue?vue&type=template&id=b42e1f2c&scoped=true"
import script from "./foodUpload.vue?vue&type=script&lang=js"
export * from "./foodUpload.vue?vue&type=script&lang=js"
import style0 from "./foodUpload.vue?vue&type=style&index=0&id=b42e1f2c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b42e1f2c",
  null
  
)

export default component.exports